"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chipTheme = exports.avatarChipTheme = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
const chipTheme = (0, _sdsThemeInternal.themed)({
  borderRadius: {
    "lodestar-light": "2px",
    "ursa-light": _designTokens.border.radius30
  },
  height: {
    medium: "28px",
    small: "24px",
    xsmall: "20px"
  },
  padding: {
    left: {
      xsmall: "0.5px",
      small: "4px",
      medium: "4px"
    },
    right: {
      xsmall: "0.5px",
      small: "6px",
      medium: "6px"
    }
  },
  showIcon: {
    "lodestar-light": false,
    "ursa-light": true
  },
  motion: {
    animation: {
      "lodestar-light": "",
      // Note: intentionally breaking away from the default transition timing since the button
      // is so small.
      "ursa-light": `background-color ${_designTokens.motion.animation.default}, opacity 0.1s ${_designTokens.motion.easing.default}`
    }
  },
  chip: {
    size: {
      "lodestar-light": "medium",
      "ursa-light": "xsmall"
    },
    color: {
      info: {
        color: "azure"
      },
      warning: {
        color: "gold"
      },
      error: {
        color: "red"
      },
      default: {
        color: "neutral"
      }
    }
  }
});
exports.chipTheme = chipTheme;
const avatarChipTheme = (0, _sdsThemeInternal.themed)({
  borderRadius: {
    "lodestar-light": "2px",
    "ursa-light": "100vmax"
  },
  padding: {
    left: {
      xsmall: {
        "lodestar-light": "0.5px",
        "ursa-light": "0px"
      },
      small: {
        "lodestar-light": "4px",
        "ursa-light": "2px"
      },
      medium: {
        "lodestar-light": "4px",
        "ursa-light": "4px"
      }
    },
    right: {
      xsmall: {
        "lodestar-light": "0.5px",
        "ursa-light": "8px"
      },
      small: {
        "lodestar-light": "6px",
        "ursa-light": "8px"
      },
      medium: {
        "lodestar-light": "6px",
        "ursa-light": "8px"
      }
    }
  },
  avatar: {
    padding: {
      "lodestar-light": "0px 2px",
      "ursa-light": "0px 4px 0px 0px"
    }
  }
});
exports.avatarChipTheme = avatarChipTheme;
//# sourceMappingURL=chipTheme.js.map